// Remove page loader after Tailwind has processed classes (prevents FOUC)
(function () {
  function revealPage() {
    var loader = document.getElementById('opus-page-loader');
    if (!loader) return;
    loader.classList.add('is-ready');
    setTimeout(function () {
      if (loader.parentNode) loader.parentNode.removeChild(loader);
    }, 300);
  }

  // Tailwind CDN fires a custom event when it's done, otherwise fallback to DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealPage);
  } else {
    revealPage();
  }
})();
